import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  header: {
    position: 'relative',
    backgroundColor: theme.palette.neutral.lightest,
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    display: 'block',
    color: 'neutral.main',
    backgroundColor: theme.palette.neutral.lightest,
  },
  clock: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& .pie': {
      animationName: '$strokeAnimate',
      animationTimingFunction: 'linear',
      animationFillMode: 'forwards',
      animationDuration: props => `${props}ms`,
    },
  },
  counter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    ...theme.typography.h4,
    color: theme.palette.neutral.dark,
    fontSize: 21,
  },
  alert: {
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  infoContainerMobile: {
    padding: theme.spacing(4, 2),
    backgroundColor: theme.palette.neutral.white,
  },
  titleMobile: {
    marginBottom: theme.spacing(2),
  },
  '@keyframes strokeAnimate': {
    to: {
      strokeDashoffset: '0px',
    },
  },
}))

export default useStyles
